import QuestCreateUpdate from "./QuestCreateUpdate.jsx";
import ViewQuestStop from "./ViewQuestStop.jsx";

export default {
  QuestCreateUpdate,
  ViewQuestStop
}
